module.exports = __webpack_public_path__ + "img/MX-C150093A-BS.0690b3db.png";